

export class EntGovernment {
  id: number | null = null;
  nameRu: string | null = null;
  nameKy: string | null = null;
  alias: string | null = null;
  parentId?: number | null = null;
}
